import api from './api'

/**
 * Serviço de Segurança/Auditoria (TENANT_ADMIN)
 * 
 * Backend: /api/tenant/security
 */
export default {
  /**
   * Listar logs de auditoria
   * GET /api/tenant/security/audit-logs?periodo=&page=&size=
   */
  listLogs(params = {}) {
    return api.get('/api/tenant/security/audit-logs', { params })
  },

  /**
   * Exportar logs (CSV)
   * GET /api/tenant/security/audit-logs/export?periodo=
   */
  exportLogs(params = {}) {
    return api.get('/api/tenant/security/audit-logs/export', {
      params,
      responseType: 'blob'
    })
  },

  /**
   * Estatísticas de auditoria
   * GET /api/tenant/security/audit-logs/stats
   */
  getStats() {
    return api.get('/api/tenant/security/audit-logs/stats')
  },

  /**
   * Atividade de login (gráfico)
   * GET /api/tenant/security/login-activity?periodo=
   */
  getLoginActivity(params = {}) {
    return api.get('/api/tenant/security/login-activity', { params })
  },

  /**
   * Distribuição de ações (gráfico)
   * GET /api/tenant/security/actions-distribution?periodo=
   */
  getActionsDistribution(params = {}) {
    return api.get('/api/tenant/security/actions-distribution', { params })
  },
}
